import { Navigate } from "react-router-dom";
import Login from "../presentaion/screens/Login/Login";
import AuthRedirect from "./AuthRedirect";

const publicRoutes = [
  {
    path: "/login",
    element: <AuthRedirect><Login /></AuthRedirect>,
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
];

export default publicRoutes;
